var React = require('react');

function EifWhite (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff}")),React.createElement("path",{"className":"a","d":"M9 6.07h16.59v5.45H9zM31.28 33.79V6.06h5.45v27.73zM9 17.21h16.59v5.45H9zM9 28.34h16.59v5.45H9zM42.41 6.07H59v5.45H42.41zM42.41 17.21H59v5.45H42.41zM42.41 28.34h5.45v5.45h-5.45z","key":1})]);
}

EifWhite.displayName = "EifWhite";

EifWhite.defaultProps = {"viewBox":"0 0 70 40"};

module.exports = EifWhite;

EifWhite.default = EifWhite;
